import React from "react";
import classNames from "classnames";
// Row
export const Row = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("tui-row", props.className)
  }, props.children);
};

// Spacer
Row.displayName = "Row";
export const Spacer = () => {
  return /*#__PURE__*/React.createElement("div", {
    className: "tui-row tui-row-spacer"
  });
};

// Column
Spacer.displayName = "Spacer";
export const Col = props => {
  const colClasses = classNames({
    "tui-col": true,
    "tui-col-xs": !props.xs,
    [`tui-col-xs-${props.xs}`]: props.xs,
    [`tui-col-sm-${props.sm}`]: props.sm,
    [`tui-col-md-${props.md}`]: props.md,
    [`tui-col-lg-${props.lg}`]: props.lg,
    [`tui-col-xs-offset-${props.xsOffset}`]: props.xsOffset,
    [`tui-col-sm-offset-${props.smOffset}`]: props.smOffset,
    [`tui-col-md-offset-${props.mdOffset}`]: props.mdOffset,
    [`tui-col-lg-offset-${props.lgOffset}`]: props.lgOffset
  }, props.className);
  return /*#__PURE__*/React.createElement("div", {
    className: colClasses
  }, props.children);
};
Col.displayName = "Col";
// Grid
export const Grid = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("tui-grid", props.className, {
      "no-spacing": props.padded === false
    })
  }, props.children);
};
Grid.displayName = "Grid";
Grid.Col = Col;
Grid.Row = Row;
Grid.Spacer = Spacer;
//# sourceMappingURL=Grid.js.map